import { inject, Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { UserService } from '../generic/service/user.service';

@Injectable()
export class AlreadyLoggedInGuardService {
    constructor(
        protected router: Router,
        private userService: UserService,
    ) {}

    /**
     * Redirect to the root of the application if the user tried to access the login page
     * but was already logged in.
     *
     * @param route
     * @param state
     * @returns {boolean}
     */
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): boolean {
        if (this.userService.isLoggedIn()) {
            this.router.navigate(['/'], {
                queryParams: { returnUrl: state.url },
            });

            return false;
        }

        return true;
    }
}

export const alreadyLoggedInGuard: CanActivateFn = (
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
): boolean => inject(AlreadyLoggedInGuardService).canActivate(next, state);
